import React from 'react'
import { Modal, Button, Icon } from 'antd'
import './RegenerationInfoModal.scss'

const RegenerationInfoModal = ({ visible, onClose, affectedScenes }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      width={520}
      className="shl-regeneration-info-modal"
    >
      <div className="shl-regeneration-info-modal__content">
        <div className="shl-regeneration-info-modal__icon-wrapper">
          <div className="shl-regeneration-info-modal__icon-bg">
            <Icon
              type="info-circle"
              className="shl-regeneration-info-modal__icon"
            />
          </div>
        </div>

        <h2 className="shl-regeneration-info-modal__title">Updating Shots</h2>

        <div className="shl-regeneration-info-modal__description">
          <p>
            We are regenerating videos for some shots to keep them perfectly
            synced with your latest changes.
          </p>

          <div className="shl-regeneration-info-modal__scene-list">
            <small>Affected Scenes & Shots:</small>
            <div className="shl-regeneration-list-container">
              {affectedScenes.map((scene, index) => (
                <div key={index} className="shl-regeneration-scene-group">
                  <div className="shl-scene-title">{scene.title}</div>
                  {scene.shots && scene.shots.length > 0 && (
                    <ul className="shl-shot-list">
                      {scene.shots.map((shot, sIndex) => (
                        <li key={sIndex} className="shl-shot-item">
                          <span className="shl-shot-title">{shot.title}</span>
                          {shot.oldDuration && shot.newDuration && (
                            <span className="shl-duration-change">
                              ({shot.oldDuration}s{' '}
                              <Icon
                                type="arrow-right"
                                style={{ fontSize: '10px', margin: '0 4px' }}
                              />{' '}
                              {shot.newDuration}s)
                            </span>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>

          <p className="shl-regeneration-info-modal__reason">
            We need to regenerate these shots because their duration has changed
            to match the voiceover timing. This ensures your final video is
            perfectly synced.
          </p>
        </div>

        <div className="shl-regeneration-info-modal__actions">
          <Button
            className="shl-regeneration-info-modal__btn shl-regeneration-info-modal__btn--confirm shl-primary-btn"
            onClick={onClose}
            type="primary"
            size="large"
            shape="round"
          >
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default RegenerationInfoModal
